import NotificationAlert from './NotificationAlert';

export default NotificationAlert;
